export const ActionIdMappingQa = {
  PUBLIC_ACTION_ID: 'PUBLIC_ACTION_ID',
  CREATE_UPDATE_SITE: '47a0fedb-9bbd-4da5-82f0-2fa0426b28f3',
  CREATE_UPDATE_AREA: '24db56c8-2603-4375-ba40-bcdef06ede62',
  CREATE_UPDATE_SHIFT: 'deedd860-7909-43d2-b927-1b442e5eb3f8',
  UPLOAD_ROSTER: '10a2aa8a-b9c6-4d9c-85b4-2ff8944deccb',
  DOWNLOAD_ROSTER: '6d988af8-6aae-4741-9f18-4daab53ce0c0',
  CREATE_HOLIDAY: '7c80caf0-d363-49bf-b80f-3c7a8dbc6794',
  CREATE_LEAVE: '6f357a1c-3991-42c5-b4e7-e5b49e54a1b2',
  UPDATE_HOLIDAY: '3f7c01f2-485f-40e2-b99e-2318f0b1879c',
  UPDATE_LEAVE: '755a613a-dad2-4d4b-b811-0c68c4b90cea',
  INITIATE_SEPARATION: 'a8083aa2-5867-446f-83c9-2c1404719e2b',
  APPROVE_REJECT_LEAVE: 'd6e59ba5-ffb6-4e4b-abe2-84fb105972d2',
  APPROVE_REJECT_SEPARATION: '1ea4243f-7dd3-44b8-bac1-772fb1124caf',
  ADD_TEAM_MEMBER: 'f12b852f-ecd7-4703-a101-397f7ecd13e0',
  APPROVE_BGV: 'b69c5181-6dbe-4943-897e-0f13dfe69182',
  GET_BGV_LIST_V2: 'eb5c52a2-8486-4dd5-a472-2b581cb98deb',
  DEBOARD_VENDOR: '698aa683-a5b7-4cc9-a9a7-1c313b4a2914',
  ASSIGN_VENDOR_AND_JOB_ID: '0c526bd8-6aeb-492a-addb-1462a55a6a15',
  WITHDRAW_APPLICATION: 'be94fe08-c659-451b-929f-5cb3e7414180',
  VERIFY_CANDIDATE_ONBOARDING: 'd003f707-339b-4b27-9597-cc7b24cbc21b',
  REVIEW: '781cd264-6a0d-48c3-b542-2442016e34aa',
  VIEW_DOCUMENTS: '9d2f2c66-2540-4d0a-af32-dc9695c4d1f2',
  REVIEW_DOCUMENTS_MANUALLY: '86dca801-334a-4d01-85d7-5b1fb16c0e89',
  REVIEW_CANDIDATURE: '15e50fcd-68fd-4623-90ba-eacd98ef8dbb',
  SCHEDULE_INTERVIEW: '98c31039-9251-4a01-a3df-a37e36afe310',
  START_INTERVIEW: 'cd457247-694f-47ff-b227-f4807e3c2cb9',
  UPLOAD_OFFER_LETTER: 'fd13b686-aeff-4103-9513-eddb36715163',
  VERIFY_ONBOARDING: '0a912325-e477-409d-adf4-ecf9b899d94f',
  EVALUATE_ONBOARDING: '3b588b06-5363-460b-840f-2e3a72d25df4',
  REQUEST_OT: '687db361-cea6-48d3-980c-4373960084aa',
  CANCEL_OT: '0b5a1088-5f66-4c41-bddd-2b1f9f2aedb6',
  REGULARISATION_REVIEW: 'dce98e5a-8843-43c7-8090-39a138f91529',
  PUNCHIN_INREVIEW: '4a460d38-6c48-4d8f-aa4b-51b01713230f',
  PUNCH_OUT_REVIEW: '76a9679c-417a-401c-ad88-d740781d032c',
  BULK_PUNCHOUT_APPROVAL: '',
  TOPUP_REVIEW: '0f278fa8-f322-4ad4-80ee-d804f6bb682b',
  OT_APPROVALS_REVIEW: '682f603d-98bc-48c7-ac08-60df0da51794',
  SPOOF_REVIEW: '431d33c3-ce05-4f8d-9bd7-a69ed7380a07',
  APPLICATION_JOURNEY: 'APPLICATION_JOURNEY',
  CONFIGURE_AREA: 'CONFIGURE_AREA',
  ACTIVITY_LOG: 'ACTIVITY_LOG',
  UPLOAD_DOCUMENTS: 'UPLOAD_DOCUMENTS',
  UPLOAD_REGULARISATION: 'aade45cc-e4bf-47b6-8cfd-3dbd23c9dfda',
  UPLOAD_BULK_USER_CREATION: '60cdc0b2-001d-4cf0-a63f-3afb5276f244',
  UPLOAD_BULK_GRACE_ATTENDANCE: 'f2ca8a23-d391-4b39-9738-a14c69b0574b',
  UPLOAD_BULK_ROLE_UPDATE: '3dd94d0b-64c3-4ecc-9ec1-937f182f8242',
  HOLD_REQUISTION: '00d6114a-ab81-4216-881b-df296508bee2',
  RESUME_REQUISTION: 'eab8152e-7c37-46b6-92e5-436910d1b8f1',
  CLOSE_REQUISTION: '7a3d5728-0840-40e5-a755-eb95993d67e5',
  BULK_CREATE_JOB_REQUISITION: '59348b33-ab2f-409f-9cc8-84acd91aac04',
  EDIT_JOB_REQUISTION: '3ea4d110-28b8-43c9-8e34-80b7eb265437',
  JOB_REQUISITION_ACTIVITY_LOG: 'JOB_REQUISITION_ACTIVITY_LOG',
  SHARE_JOB_DETAILS: 'dd1163e6-5154-4d5e-96a0-bfb80c2aa359',
  REFER_LEAD_WITH_CSV: '59d0a213-4fa1-43f0-9a8c-def6d29cb7a5',
  JOB_REQUISITION_ADD_CANIDATE: 'JOB_REQUISITION_ADD_CANIDATE',
  ONBOARDING_REVIEW_DOCUMENTS_MANUALLY: '83f07ef2-1dac-4e92-8517-1a6da84d17b3',
  ONBOARDING_VIEW_DOCUMENTS: '641e1545-28ae-4885-b26a-c9b832ca239c',
  ONBOARDING_VERIFY_BANK_UAN_DETAILS: 'bb178a4c-f514-4862-911b-30a016320d9e',

  ONBOARDING_RETRY_LMS: '08e3047c-bde7-4e8f-863b-784fb294a9e3',
  ONBOARDING_RETRY_BGV: '08e3047c-bde7-4e8f-863b-784fb294a9e3',
  ONBOARDING_RETRY_THOR: '08e3047c-bde7-4e8f-863b-784fb294a9e3',
  CREATE_FLEX_SLOT: 'b4f70182-c33c-42ad-a4b9-c1d4b18f01b3',
  CREATE_FLEX_SITE: '2385bd06-3b05-481d-9b3a-d35d194cf099',
  CANCEL_FLEX_SITE: '05757272-ffa0-45e6-858b-c991004bd0ff',
  UPLOAD_CSV_FOR_FLEX_SITE: 'c4fa04e6-b655-4dc7-8c07-494218581ddc',
  DOWNLOAD_CSV_FOR_FLEX_SITE: 'fe56f908-857d-45ca-ad90-18414ee7bce6',
  EDIT_FLEX_SITE: '2385bd06-3b05-481d-9b3a-d35d194cf099',
  VIEW_DETAIL_FLEX_SITE: 'bd2ff3b5-80f3-4fd2-98bf-763acdebfccc',
  APPROVAL_PAYSHEET_FLEX_PAYOUT: '8fbd5f23-a252-4586-847e-d2fef5fc029d',
  UPDATE_TICKETS_BY_ID: '99305d95-eb84-4fd2-8da2-cbf2b16c89e0',
  BULK_DOWNLOAD_GRIEVANCE_TICKET: '29f7baeb-f998-4803-8794-100d6584e269',
  DOWNLOAD_ZIP_FILE_GRIEVANCE: '25e21870-a0c7-4818-b301-cf2c4258eb89',
  VENDOR_ONBOARDING: 'ee85c13a-7c13-4688-aab1-351390f95890',
  CREATE_TEMPORARY_TRANSFER: '67c09e2b-6390-4a74-8b60-cb456c3033bc',
  CREATE_PERMANENT_TRANSFER: '02689f76-d256-4645-9184-1f59d062fc00',

  APPROVE_REJECT_TRANSFER: 'd78849c6-6ea6-4890-b9b2-228be45c4b03',

  EDIT_TEMPORARY_TRANSFER: '312e70d9-a3fe-41a3-addc-428fb410826c',
  EDIT_PERMANENT_TRANSFER: '7f3f2ae1-3432-4dce-93f7-d84f37d731ef',

  CANCEL_TEMPORARY_TRANSFER: '7fe1e09c-6cec-49c8-adad-7db0a62a29db',
  CANCEL_PERMANENT_TRANSFER: 'd265e28c-68f2-47d1-800f-232854beb7f0',

  EDIT_EMPLOYEE_TEMPORARY_TRANSFER: '398a7625-7b4b-4e9f-9ee3-7a891af0cc46',
  EDIT_EMPLOYEE_PERMANENT_TRANSFER: '3019b316-33a1-4324-a5c4-3a6d5fe28466',

  CANCEL_EMPLOYEE_TEMPORARY_TRANSFER: '03adf4b3-9801-4e96-8833-199621dc24f4',
  CANCEL_EMPLOYEE_PERMANENT_TRANSFER: 'dfb96e3a-fe91-4eec-affd-631e1b07d221',
  UPDATE_EMPLOYEE_SHIFT_ROSTER: 'ed2e38b4-ebc0-417b-849e-ccefd30ae854',
  DOWNLOAD_CTC_MAPPING: 'af80657a-b5cc-4bc8-81df-21ded901a2ca',
  UPDATE_CTC_MAPPING: '52465057-5491-4607-acf2-082fcdf1ac33',

  VENDOR_PAYOUT_DOWNLOAD: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  PROCESSED_PAYOUT_DOWNLOAD: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  PROCESSED_PAYOUT_VIEW_DOWNLOAD: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',

  BULK_PUNCHIN_APPROVAL: 'd92ceb56-93a8-41bc-93d3-563119c9f13b',
  DOWNLOAD_PLAN: '6067a788-fe8a-4f4e-b5b1-da97343dac3d',
  REQUEST_ROSTER_PLAN: 'be18e952-657b-4844-b1d2-a32991008884',
  VIEW_ROSTER_ATTENDANCE_SUMMARY: 'fcf9912f-bb62-4fed-a53a-39b648ed0673',
  VIEW_ROSTER_EMPLOYEE_DETAILS: '4dddf5bd-fdb0-4e2b-92a8-3714e7012b37',
  REVIEW_ABSCONDING_REQUEST: '12e486b0-45de-4e76-aa7f-27373ff4a385',
  // Incentive Management Actions
  CREATE_INCENTIVE: '60bdddea-c603-42ea-8987-f7fa54eebc84',
  REVIEW_INCENTIVE: 'fe79c195-c6a5-4de7-a029-f19499df4df1',
  UPDATE_INCENTIVE: '0933ded8-e536-4337-be3d-dc9509dd6e28',
  MARK_INCENTIVE_INACTIVE: '0f687009-b209-47b4-a6b4-1f37cb2bd047',

  // Payroll actions
  PAYROLL_DOWNLOAD: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  PAYROLL_UPLOAD: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  PAYROLL_VIEW_HISTORY: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  PAYROLL_FREEZE: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  PAYROLL_DOWNLOAD_INVOICE: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  PAYROLL_ACK_INVOICE: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  PAYROLL_DOWNLOAD_PAYSHEET: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  PAYROLL_ACK_UTR: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  PAYROLL_DOWNLOAD_UTR: '7b3a4421-ac61-4f47-ba8c-db7261a4234f',
  EDIT_OL_PRE_ONBOARDING_DETAILS: '08671b74-4b0b-4762-8cee-c7ba8e5cab73',
  BULK_DOWNLOAD_PRE_ONBOARDING: 'fd6b07ac-f930-40ed-8304-1dee19b56421',
  UPLOAD_OFFER_LETTER_PRE_ONBOARDING: '3eee3bff-b7da-47bd-98e1-198a195be65c',

  // Flex Rate Card Management Actions
  CREATE_UPDATE_FLEX_RATE_CARD: '4981e762-95ef-43d6-a209-e5f09ced3df3',
  VIEW_FLEX_RATE_CARD_LIST: 'e3a5c928-53a4-4f62-96d6-0ae01c0298f1',
  DOWNLOAD_FLEX_RATE_CARD: '6799e076-1a3a-48b1-ab15-6efccc12272a',
  UPLOAD_FLEX_UTR_SHEET: '217473e8-f81d-4f22-97a3-98a42e016aba',
  UPDATE_FLEX_EARNINGS: 'd796c1fe-9d81-495e-9689-a1d74090c05c',
  APPROVE_FLEX_EARNINGS: 'e874d1bc-5339-4c0b-bc3a-3b84772e682f',
  UPLOAD_PAYSHEET_EDGE: 'c8a0a8c5-f574-4f5f-877a-d4151d99b506',
  UPLOAD_UTR_EDGE: '5489fe29-48d3-4f4b-86f2-2e5307577fd9',

  CREATE_EDIT_REFERRAL_RATE_CARD: 'b16d945c-537d-4fc4-adf5-8f8b8fbf0879',
  DOWNLOAD_REFERRAL_RATE_CARD: 'ccc31f92-808d-44b9-8bbd-63751769a5de',

  // Addendum Management Actions
  VIEW_ADDENDUM_STATS: 'a3ae0250-e0e5-4a08-8075-6b1d79622dfb',
  VIEW_ADDENDUMS_LIST: '9ca6897b-3adc-42aa-a17a-a587720808f1',

  DOWNLOAD_RATE_CARD_MANAGEMENT: '5599d710-7363-4de2-bdf2-0d8baff92f4b',
  UPLOAD_RATE_CARD_MANAGEMENT: '765e6600-a7fb-484e-9031-09d1b14973e8',
  CREATE_UPDATE_FT_RATE_CARD: 'd16d2ce5-f923-475e-b176-3da08e8da456',

  UPLOAD_FT_FLEX_SLOTS: '3138ecd6-42ea-45ee-ba63-e98ea610a4c8',

  REVIEW_IT_REQUEST: '3383408f-be03-4ffc-8f17-a30ac2b29c25',
  GET_IT_REVIEWS: '79ce7097-b168-417f-8845-bf069fb3aecc',
  DOWNLOAD_IT_REVIEWS_REPORT: '0090a227-a951-447d-979b-819673225692',
  UPDATE_EMPLOYEE_ASSET: '42a57895-6dc9-408f-b6dd-40c54dc05732',
  GET_EMPLOYEE_ASSETS: 'a8721849-73c3-4044-9483-d69b9a114b39',

  // Payout Processing - Internal
  ZPL_EDGE_ONGOING_PAYOUT_VIEW: 'd4b9b070-4b06-476e-a4eb-695beee6a457',
  ZPL_EDGE_PROCESSED_PAYOUT_VIEW: 'f23687b9-155d-4a75-9dd8-a473d347d4a9',
  MH_ZPL_EDGE_ONGOING_PAYOUT_VIEW: 'c6354704-5d81-42e2-84d6-98216a58510b',
  MH_ZPL_EDGE_PROCESSED_PAYOUT_VIEW: '5bd6d4ee-c47f-4189-8ac1-403a3fab444b',
  ZPL_EDGE_UPDATE_PAYOUT_STATUS: '881f7ed5-5e97-48f5-9e68-0ccb40b69220',
  MH_ZPL_EDGE_UPDATE_PAYOUT_STATUS: '6fa461b8-9615-4593-8a7c-d463a670c666',
  ZPL_EDGE_GET_PAYROLL_CYCLES: '7a60d892-5495-462b-883e-ad8f8a10f774',
  MH_ZPL_EDGE_GET_PAYROLL_CYCLES: '7bc14df8-d4b1-488b-88fe-71523d4c9310',

  REVIEW_POST_ONBOARDING_REQUEST: 'dc1cebf0-c8eb-4a70-9824-33866a94ce51',

  DOWNLOAD_HRMS_SHIKSHA_INTEREST_REPORT: 'c882f9a7-e9b5-46da-bb71-1bab9dc341f1',

  GET_ROLE_CTC_SUMMARY: '55365c3c-6fa8-47d4-ad93-e64487ecf26c',
};
